const dict: Record<string, string> = {
  // Nav
  dashboard: "Pulpit",
  catalog: "Katalog",
  cart: "Koszyk",
  orders: "Zamówienia",
  account: "Konto",
  invoices: "Faktury",
  nav_main: "Praca",
  nav_account: "Konto",

  // Common
  search: "Szukaj",
  search_products: "Szukaj po SKU, nazwie...",
  filter: "Filtr",
  sort: "Sortuj",
  add_to_cart: "Dodaj",
  in_cart: "W koszyku",
  place_order: "Złóż zamówienie",
  add_short: "Dodaj",
  add_more: "Dodaj więcej",
  total: "Razem",
  subtotal: "Suma częściowa",
  discount: "Rabat",
  delivery: "Dostawa",
  qty: "Ilość",
  qty_decrement: "Zmniejsz ilość",
  qty_increment: "Zwiększ ilość",
  logist_addr_derybasivska: "Derybasivska 12",
  logist_addr_tairova: "Tairova · Hłuszka 32",
  logist_addr_sklad: "Magazyn · Promysłowa 4",
  unit: "Za sztukę",
  price: "Cena",
  retail: "Detal",
  your_price: "Twoja cena",
  saved: "Oszczędzasz",
  sku: "SKU",
  stock: "Stan",
  in_stock: "Dostępne",
  low_stock: "Mało",
  out_of_stock: "Brak",
  create_order: "Utwórz zamówienie",
  repeat_order: "Powtórz zamówienie",
  view_all: "Wszystkie",
  items: "Pozycje",
  items_word: "pozycji",
  amount: "Kwota",
  product: "Produkt",
  status: "Status",
  payment: "Płatność",
  paid: "Opłacone",
  unpaid: "Nieopłacone",
  free: "Bezpłatnie",
  optional: "opcjonalne",
  clear: "Wyczyść",
  retry: "Ponów",
  repeat: "Powtórz",
  invoice: "Faktura",
  order: "Zamówienie",
  date: "Data",
  due: "Termin płatności",
  due_by: "do",
  primary: "Główny",
  primary_m: "Główny",
  yes: "Tak",
  no: "Nie",
  all: "Wszystkie",
  view: "Podgląd",
  admin: "Admin",
  user: "Użytkownik",
  invite: "Zaproś",
  added: "Dodano:",
  category: "Kategoria",

  // Status
  status_new: "Nowe",
  status_processing: "W realizacji",
  status_shipped: "Wysłane",
  status_delivered: "Dostarczone",
  status_cancelled: "Anulowane",

  // Login
  login_title: "Logowanie do portalu B2B",
  login_sub: "Uzyskaj dostęp do zamówień hurtowych dla swojej firmy.",
  email: "Email",
  password: "Hasło",
  show_password: "Pokaż hasło",
  hide_password: "Ukryj hasło",
  forgot: "Zapomniałeś hasła?",
  sign_in: "Zaloguj się",
  or: "lub",
  magic: "Wyślij link do logowania",
  magic_link_send: "Wyślij magiczny link",
  magic_check_email: "Sprawdź e-mail",
  no_account: "Nie masz dostępu?",
  request: "Poproś o konto",
  wholesale_portal: "Portal hurtowy",
  signing_in: "Logowanie...",
  invalid_email: "Nieprawidłowy email",
  r_required_field: "Wypełnij wymagane pola",
  r_submit_error: "Nie udało się wysłać zgłoszenia. Spróbuj ponownie.",
  check_inbox: "Sprawdź skrzynkę",
  magic_sent: "Wysłaliśmy link do logowania na",
  magic_expire: "Link wygasa za 15 minut.",
  back_to_password: "Powrót do hasła",
  brand_panel_copy:
    "Zamawiaj ziarna, sprzęt i akcesoria bezpośrednio z palarni z indywidualnymi cenami, terminem płatności NET-14 i dedykowanym opiekunem.",
  partner_venues: "lokali partnerskich",
  on_market: "na rynku",
  payment_terms_label: "warunki płatności",

  // Dashboard
  welcome: "Witaj ponownie",
  your_tier: "Twój pakiet",
  personal_manager: "Osobisty opiekun",
  balance: "Saldo",
  recent_orders: "Ostatnie zamówienia",
  quick_actions: "Szybkie akcje",
  today_date_long: "18 KWIETNIA 2026 · SOBOTA",
  dash_sub_a: "Saldo, zamówienia i szybkie akcje dla ",
  dash_sub_b: ".",
  credit: "Kredyt",
  tier_b_hint: "Indywidualne ceny — 20% od detalu",
  saved_this_year: "Zaoszczędzono w tym roku",
  across_word: "w",
  orders_word: "zamówieniach",
  active_orders: "Aktywne zamówienia",
  one_processing: "1 w realizacji",
  send_message: "Wyślij wiadomość",
  whats_new: "Nowości",
  frequent_items: "Twoje stałe pozycje",
  one_click_reorder: "Dodaj do koszyka jednym kliknięciem",

  // Catalog
  categories: "Kategorie",
  availability: "Dostępność",
  origin: "Pochodzenie",
  weight: "Waga",
  cat_beans: "Ziarno",
  cat_ground: "Mielona / drip",
  cat_equipment: "Sprzęt",
  cat_accessories: "Akcesoria",
  cat_training: "Szkolenia",
  view_grid: "Siatka",
  view_table: "Tabela",
  wholesale_catalog: "Katalog hurtowy",
  catalog_sub_a: " pozycji · Ceny uwzględniają Twoje warunki HoReCa Tier B",
  any_availability: "Dowolna dostępność",
  featured: "Polecane",
  price_low_high: "Cena: rosnąco",
  price_high_low: "Cena: malejąco",
  alpha: "A → Z",
  all_items: "Wszystkie produkty",
  catalog_err: "Nie udało się załadować katalogu",
  catalog_err_sub: "Sprawdź połączenie i spróbuj ponownie.",
  nothing_found: "Nic nie znaleziono",
  nothing_found_sub: "Spróbuj innych słów kluczowych lub wyczyść filtry.",
  clear_filters: "Wyczyść filtry",
  restocking: "W drodze",

  // Cart
  your_cart: "Twój koszyk",
  empty_cart: "Koszyk jest pusty",
  empty_cart_sub: "Dodaj produkty z katalogu, aby rozpocząć zamówienie.",
  go_to_catalog: "Do katalogu",
  order_summary: "Podsumowanie zamówienia",
  delivery_address: "Adres dostawy",
  payment_method: "Metoda płatności",
  payment_terms: "Płatność po dostawie (NET-14)",
  delivery_method: "Sposób dostawy",
  choose_one: "Wybierz jedną opcję",
  odesa_logist: "Własny kurier · Odessa",
  odesa_logist_meta: "1–2 dni robocze · w mieście",
  odesa_logist_short: "Kurier Odessa",
  np_short: "Nova Poshta",
  min_prefix: "min.",
  available_from: "Dostępne od",
  shortfall_a: "Dodaj jeszcze ",
  shortfall_b:
    ", aby skorzystać z własnego kuriera — lub wybierz Nova Poshta poniżej.",
  add_items: "Dodaj produkty",
  switch_to_np: "Przejdź na Nova Poshta",
  np_switched_toast:
    "Dostawa przełączona na Nova Poshta: suma zamówienia poniżej 2 000 ₴",
  np_branch: "Nova Poshta · oddział",
  np_meta: "1–3 dni robocze · cała Ukraina",
  city: "Miasto",
  branch_num: "Nr oddziału",
  order_note: "Komentarz do zamówienia",
  order_note_ph: "Uwagi dotyczące dostawy, oznakowania itp...",
  delivery_via_odesa: "Dostawa · Kurier Odessa",
  delivery_via_np: "Dostawa · Nova Poshta",
  incl_vat: "W tym VAT 20% ·",
  payment_status_unpaid: "Status płatności: Nieopłacone",
  payment_status_unpaid_sub:
    "Zamówienie tworzone bez natychmiastowej płatności. Opiekun wyśle fakturę.",
  net14_note: "Bez natychmiastowej płatności · NET-14",
  order_copied: "Zamówienie skopiowane do koszyka",
  order_created_a: "Zamówienie utworzone ·",
  order_created_b: "· Nieopłacone",
  order_error: "Nie udało się złożyć zamówienia. Spróbuj ponownie.",

  // Orders
  order_history: "Historia zamówień",
  order_num: "Nr zamówienia",
  ordered_on: "Data",
  orders_total_suffix: " zamówień łącznie · Kliknij, aby zobaczyć szczegóły",
  search_by_num: "Szukaj po numerze...",
  no_orders: "Brak zamówień",
  fulfilment: "Dostawa",
  line_items: "Pozycje",
  unpaid_awaiting: "Nieopłacone · oczekuje na fakturę",
  payment_colon: "Płatność:",
  download_invoice: "Pobierz fakturę",
  invoice_sent: "Faktura wysłana na e-mail",

  // Account
  company: "Firma",
  addresses: "Adresy",
  payment_methods: "Płatność",
  account_settings: "Konto i ustawienia",
  account_sub: "Zarządzaj firmą, adresami dostawy i metodami płatności.",
  team: "Zespół",
  preferences: "Preferencje",
  company_details: "Dane firmy",
  save_changes: "Zapisz zmiany",
  legal_name: "Nazwa prawna",
  brand_name: "Nazwa marki",
  tax_id: "NIP",
  vat_registered: "Płatnik VAT",
  billing_email: "Email rozliczeniowy",
  phone: "Telefon",
  your_manager: "Twój opiekun",
  payment_terms_row: "Warunki płatności",
  customer_since: "Klient od",
  upgrade_tier: "Awans na Tier A przy 500 000 UAH/rok — brakuje 84 000 UAH.",
  credit_line: "Linia kredytowa",
  available_word: "dostępne",
  used: "Wykorzystane",
  limit: "Limit",
  delivery_addresses: "Adresy dostawy",
  add_address: "Dodaj adres",
  payment_methods_title: "Metody płatności",
  add_method: "Dodaj metodę",
  net14_apply:
    "Warunki NET-14 są automatycznie stosowane do zamówień powyżej 5 000 UAH.",
  owner_role: "Właściciel",
  procurement: "Specjalista zakupów",
  head_barista: "Główny barista",
  team_members: "Członkowie zespołu",
  team_role: "Uprawnienia",
  role_orders: "Zamówienia",
  notifications: "Powiadomienia",
  help: "Pomoc",
  menu: "Menu",
  search_placeholder: "Szukaj wszędzie...",
  close: "Zamknij",
  guest: "Gość",
  logout: "Wyloguj",
  remove: "Usuń",
  notif_status: "Zmiany statusu zamówienia",
  notif_restock: "Powiadomienia o uzupełnieniu",
  notif_new_arrivals: "Nowości w katalogu",
  notif_promo: "Promocje sezonowe",

  // Invoices
  invoices_title: "Faktury i dokumenty",
  invoices_sub: "Faktury VAT, dokumenty dostawy i potwierdzenia.",
  export_csv: "Eksport CSV",

  // Not found
  not_found_title: "Strony nie znaleziono",
  not_found_subtitle:
    "Link może być nieaktualny albo strona została przeniesiona.",
  go_to_dashboard: "Przejdź do panelu",

  // Misc
  today: "dziś",
  yesterday: "wczoraj",
  days_ago: "dni temu",

  // Register
  r_eyebrow: "Portal hurtowy · Aplikacja",
  r_title: "Poproś o konto",
  r_sub:
    "Opowiedz nam o swoim biznesie — opiekun przygotuje indywidualną ofertę w 1 dzień roboczy.",
  r_s1: "Firma",
  r_s2: "Lokal",
  r_s3: "Kontakt",
  r_step: "Krok",
  r_of: "z",
  r_company_legal: "Nazwa prawna",
  r_company_hint: "Sp. z o.o. / DG",
  r_edrpou: "NIP",
  r_vat: "Płatnik VAT",
  r_yes: "Tak",
  r_no: "Nie",
  r_brand_name: "Nazwa lokalu (marka)",
  r_brand_hint: "Nazwa widoczna dla klientów",
  r_venue_type: "Typ lokalu",
  r_cafe: "Kawiarnia",
  r_restaurant: "Restauracja",
  r_hotel: "Hotel",
  r_office: "Biuro / korporacja",
  r_reseller: "Reseller",
  r_other: "Inne",
  r_venues: "Liczba lokalizacji",
  r_volume: "Szacunkowe miesięczne zużycie kawy",
  r_v1: "Do 20 kg",
  r_v2: "20–50 kg",
  r_v3: "50–150 kg",
  r_v4: "Powyżej 150 kg",
  r_name_full: "Imię i nazwisko",
  r_role: "Twoja rola",
  r_owner: "Właściciel",
  r_buyer: "Zakupowiec",
  r_barista: "Główny barista",
  r_manager: "Manager",
  r_email: "Email służbowy",
  r_phone: "Telefon",
  r_note: "Komentarz dla opiekuna",
  r_note_ph: "Co obecnie zamawiasz, ulubione marki, specjalne potrzeby...",
  r_accept_tos: "Zgadzam się z warunkami współpracy i przetwarzaniem danych",
  r_accept_tos_required: "Musisz zaakceptować warunki",
  r_continue: "Dalej",
  r_back: "Wstecz",
  r_submit: "Wyślij wniosek",
  r_have_account: "Masz już konto?",
  r_sign_in: "Zaloguj się",
  r_sent_title: "Wniosek przyjęty!",
  r_sent_sub:
    "Anna Lytvyn, Twój przyszły opiekun, skontaktuje się w ciągu 24 godzin pod numerem",
  r_what_next: "Co dalej",
  r_n1: "Opiekun zweryfikuje dane i ustali indywidualne ceny HoReCa",
  r_n2: "Otrzymasz email z loginem i tymczasowym hasłem",
  r_n3: "Pierwsze zamówienie — z rabatem −5% na całość",
  r_back_to_site: "Powrót do foundation.ua",
  r_why_title: "Co zyskujesz jako partner B2B",
  r_w1_t: "Indywidualne ceny",
  r_w1_s: "Stawki HoReCa od −15% do −25% od detalu",
  r_w2_t: "Płatność NET-14",
  r_w2_s: "Odroczona płatność dla stałych partnerów",
  r_w3_t: "Osobisty opiekun",
  r_w3_s: "Bezpośredni kontakt, bez kolejki",
  r_w4_t: "Priorytetowa dostawa",
  r_w4_s: "Następny dzień w Odessie, 2 dni w całej Ukrainie",
  r_for_venues: "Dla lokali i resellerów",
  r_hero_a: "Zostań",
  r_hero_b: "partnerem",
  r_hero_c: "Foundation.",
  r_bottom_copy:
    "Ponad 240 lokali w Ukrainie zamawia ziarna, sprzęt i akcesoria bezpośrednio z naszej palarni w Odessie.",
};

export default dict;
